<template>
  <div v-if="activity">
    <span class="ivu-table-cell-tooltip-content">
      <h3> {{ activity.label }} </h3>
      <div class="body">{{ activity.description }}</div>
    </span>
  </div>
</template>

<script>
export default {
  name: 'ActivityLabelDisplay',
  props: {
    activity: {
      type: Object
    }
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="less" scoped>
.ivu-table-cell-tooltip-content {
  h3 { margin: 5px 0; }
}
</style>
